import { Sparkles, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { OFFERS } from "../config/offers";
import { waLink } from "../config/site";

const FESTIVE = OFFERS.filter((o) => o.tag === "Festive Offer");

export const FestiveOffers = () => (
  <section
    id="offers"
    className="relative overflow-hidden bg-gold text-charcoal border-y border-gold-deep/30"
  >
    <div
      className="absolute inset-0 opacity-[0.08]"
      style={{
        backgroundImage:
          "radial-gradient(circle at 20% 30%, #121212 1.5px, transparent 1.5px), radial-gradient(circle at 80% 70%, #121212 1.5px, transparent 1.5px)",
        backgroundSize: "38px 38px",
      }}
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 relative grid lg:grid-cols-12 gap-10 items-center">
      <Reveal className="lg:col-span-5">
        <p className="font-mono text-xs uppercase tracking-[0.28em] text-charcoal/70">
          Festive Offers · Diwali, Ugadi & every celebration
        </p>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-balance leading-[1.05]">
          Every festival, <span className="italic font-medium">a reason to shop.</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-charcoal/70 leading-relaxed">
          On every festival we celebrate with you — flat discounts on garments
          and footwear for the whole family. Message us to check what's on today.
        </p>
        <a
          href={waLink(
            "Hello Om Sri Sri Collection, I would like to know about your current festive offers."
          )}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="offers-whatsapp-button"
          className="mt-8 inline-flex items-center gap-2.5 bg-charcoal text-cream font-semibold rounded-full px-7 py-3.5 hover:bg-black transition-all duration-300 hover:-translate-y-0.5"
        >
          <MessageCircle size={17} /> Ask About Today's Offers
        </a>
      </Reveal>

      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
        {FESTIVE.map((o, i) => {
          const pct = o.text.match(/\d+%/)?.[0];
          const item = o.id.includes("footwear") ? "Footwear" : "Garments";
          return (
            <Reveal key={o.id} delay={i * 0.1}>
              <div
                data-testid={`festive-offer-card-${item.toLowerCase()}`}
                className="h-full rounded-3xl bg-charcoal text-cream p-7 sm:p-8 border border-white/10 flex flex-col"
              >
                <span className="inline-flex items-center gap-1.5 self-start rounded-full border border-gold/40 bg-gold/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                  <Sparkles size={12} /> Festive
                </span>
                <p className="mt-6 font-display text-6xl sm:text-7xl font-bold text-gold leading-none">
                  {pct}
                  <span className="text-2xl sm:text-3xl font-medium text-cream/70 ml-1">off</span>
                </p>
                <p className="mt-3 font-display text-2xl font-semibold">{item}</p>
                <p className="mt-2 text-sm text-cream/55 leading-relaxed flex-1">
                  Flat discount on every festival. Message us on WhatsApp to
                  confirm today's offer.
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
